module.exports = __webpack_public_path__ + "img/ico-login.1c5ab541.svg";